import React from 'react';
import AtlasRatingsV2ProductGrid from 'src/components/AtlasV2Components/AtlasRatingsV2PageComponots/AtlasRatingsProductV2Grid';
import { AtlasRatingsV2TopSection } from 'src/components/AtlasV2Components/AtlasRatingsV2PageComponots/AtlasRatingsV2TopSection';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import BasePageContainer from 'src/components/CommonV2Components/BasePageContainer/BasePageContainer';
import { BEACON_CHART_SPACING } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';
import { useAtlasV2TabTreatmentRedirect } from 'src/components/AtlasV2Components/Hooks/useAtlasV2TabTreatmentRedirect';

/**
 * Atlas Ratings V2 Page layout - Tab name: rating subtab name: rating
 */
export const AtlasRatingsV2PageLayout = () => {
  const { isRedirecting } = useAtlasV2TabTreatmentRedirect();
  if (isRedirecting) return null;

  return (
    <BasePageContainer>
      <Flex flexDirection="column" gap={BEACON_CHART_SPACING}>
        <AtlasRatingsV2TopSection />
        <AtlasRatingsV2ProductGrid />
      </Flex>
    </BasePageContainer>
  );
};
